import { html } from '@grins/views/util/html.ts';

export type OneTrustScriptsLocals = {
  enabled: boolean;
  jsScriptBlock?: string;
  scriptURL?: string;
  domainScript?: string;
  integrityHash?: string;
};

export const oneTrustScripts = (locals?: OneTrustScriptsLocals) =>
{
  if (!locals) {
    return html`
    <!-- OneTrust Cookies Consent Notice unavailable -->
    `;
  }

  if(locals.jsScriptBlock) {
    return locals.jsScriptBlock;
  }

  return html`
    <!-- OneTrust Cookies Consent Notice start for fandango.com -->
    <script type="text/javascript" charset="UTF-8" crossorigin="anonymous"
        src=${locals.scriptURL}
        data-domain-script=${locals.domainScript}
        integrity=${locals.integrityHash}
    ></script>
    <script type="text/javascript">function OptanonWrapper() { }</script>
    <!-- OneTrust Cookies Consent Notice end for fandango.com -->
  `;
}
